module.exports = __webpack_public_path__ + "img/om.c248f227.svg";